module.exports = __webpack_public_path__ + "static/media/flightStatisticSS.15cefa73.png";